function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApiConstants from 'invision-core/src/api/constants';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { ContextOfferingAction } from '../constants/wizard.constants';
import { getContractId } from './offering.order.actions';
export var RETRIEVE_OFFERING_REMOVAL_CONTEXT = {
  BEGIN: 'RETRIEVE_OFFERING_REMOVAL_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_OFFERING_REMOVAL_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_OFFERING_REMOVAL_CONTEXT_FAILURE'
};
var RETRIEVE_OFFERING_REMOVAL_CONTEXT_TYPES = [RETRIEVE_OFFERING_REMOVAL_CONTEXT.BEGIN, RETRIEVE_OFFERING_REMOVAL_CONTEXT.SUCCESS, RETRIEVE_OFFERING_REMOVAL_CONTEXT.FAILURE];
export var CHANGE_OF_SERVICE_REMOVAL = {
  BEGIN: 'CHANGE_OF_SERVICE_REMOVAL_BEGIN',
  SUCCESS: 'CHANGE_OF_SERVICE_REMOVAL_SUCCESS',
  FAILURE: 'CHANGE_OF_SERVICE_REMOVAL_FAILURE'
};
var CHANGE_OF_SERVICE_REMOVAL_TYPES = [CHANGE_OF_SERVICE_REMOVAL.BEGIN, CHANGE_OF_SERVICE_REMOVAL.SUCCESS, CHANGE_OF_SERVICE_REMOVAL.FAILURE];
export var CALCULATE_COS_QUOTE = {
  BEGIN: 'CALCULATE_COS_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_COS_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_COS_QUOTE_FAILURE'
};
var CALCULATE_COS_QUOTE_TYPES = [CALCULATE_COS_QUOTE.BEGIN, CALCULATE_COS_QUOTE.SUCCESS, CALCULATE_COS_QUOTE.FAILURE];
export var retrieveOfferingRemovalContext = function retrieveOfferingRemovalContext(removeItemIds, subscriberId) {
  var contractId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return function (dispatch) {
    return retrieveOfferingRemovalContextPromise(dispatch, removeItemIds, subscriberId, contractId);
  };
};
export var retrieveOfferingRemovalContextPromise = function retrieveOfferingRemovalContextPromise(dispatch, removeItemIds, subscriberId, contractId) {
  var data = {
    Offerings: removeItemIds.map(function (removeItem) {
      return {
        Action: ContextOfferingAction.REMOVE,
        OfferingId: removeItem.offeringId,
        OfferingInstanceId: removeItem.offeringInstanceId
      };
    }),
    ContractId: contractId || getContractId()
  };
  return ThunkHelper(dispatch, RETRIEVE_OFFERING_REMOVAL_CONTEXT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: data
  });
};
export var submitChangeOfServiceRemoval = function submitChangeOfServiceRemoval(ItemsToRemove, subscriberId) {
  var executionOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    return submitChangeOfServiceRemovalPromise(dispatch, ItemsToRemove, subscriberId, executionOptions);
  };
};
var submitChangeOfServiceRemovalPromise = function submitChangeOfServiceRemovalPromise(dispatch, ItemsToRemove, subscriberId, executionOptions) {
  return ThunkHelper(dispatch, CHANGE_OF_SERVICE_REMOVAL_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitChangeOfServiceOrder',
    headers: {
      'CD-SubscriberId': subscriberId
    },
    data: {
      Comment: executionOptions.disconnectComment,
      ExecutionDate: executionOptions.specifiedDate,
      ExecutionDateIntention: executionOptions.effective,
      ReasonCode: executionOptions.disconnectReason ? executionOptions.disconnectReason.Value || executionOptions.disconnectReason : undefined,
      RemoveItems: ItemsToRemove
    }
  });
};
export var calculateChangeOfServiceQuote = function calculateChangeOfServiceQuote(ItemsToRemove, subscriberId, reasonCode) {
  return function (dispatch) {
    return calculateChangeOfServiceQuotePromise(dispatch, ItemsToRemove, subscriberId, reasonCode);
  };
};
export var calculateChangeOfServiceQuotePromise = function calculateChangeOfServiceQuotePromise(dispatch, ItemsToRemove, subscriberId, reasonCode) {
  return ThunkHelper(dispatch, CALCULATE_COS_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateChangeOfServiceOrderQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: {
      ReasonCode: reasonCode || undefined,
      RemoveItems: ItemsToRemove
    }
  });
};

// NEW APIs for Full Subscriber Disconnects
export var DISCONNECT_SUBSCRIBER_QUOTE = {
  BEGIN: 'DISCONNECT_SUBSCRIBER_QUOTE_BEGIN',
  SUCCESS: 'DISCONNECT_SUBSCRIBER_QUOTE_SUCCESS',
  FAILURE: 'DISCONNECT_SUBSCRIBER_QUOTE_FAILURE'
};
var DISCONNECT_SUBSCRIBER_QUOTE_TYPES = [DISCONNECT_SUBSCRIBER_QUOTE.BEGIN, DISCONNECT_SUBSCRIBER_QUOTE.SUCCESS, DISCONNECT_SUBSCRIBER_QUOTE.FAILURE];
export var DISCONNECT_SUBSCRIBER = {
  BEGIN: 'DISCONNECT_SUBSCRIBER_BEGIN',
  SUCCESS: 'DISCONNECT_SUBSCRIBER_SUCCESS',
  FAILURE: 'DISCONNECT_SUBSCRIBER_FAILURE'
};
var DISCONNECT_SUBSCRIBER_TYPES = [DISCONNECT_SUBSCRIBER.BEGIN, DISCONNECT_SUBSCRIBER.SUCCESS, DISCONNECT_SUBSCRIBER.FAILURE];
export var disconnectSubscriberQuote = function disconnectSubscriberQuote(subscriberId) {
  var etfFeeOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var etfWaiveReasons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var reasonCode = arguments.length > 3 ? arguments[3] : undefined;
  var enableOptionalQuoteOverride = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch) {
    return disconnectSubscriberQuotePromise(dispatch, subscriberId, etfFeeOverride, etfWaiveReasons, reasonCode, enableOptionalQuoteOverride);
  };
};
export var disconnectSubscriberQuotePromise = function disconnectSubscriberQuotePromise(dispatch, subscriberId, etfFeeOverride, etfWaiveReasons, reasonCode, enableOptionalQuoteOverride) {
  return ThunkHelper(dispatch, DISCONNECT_SUBSCRIBER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/DisconnectSubscriberQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: {
      EarlyTerminationFeeOverrideReason: etfWaiveReasons,
      IsEarlyTerminationFeeOverride: etfFeeOverride,
      ReasonCode: reasonCode || undefined,
      CalculateQuoteOverridingConfiguration: enableOptionalQuoteOverride
    }
  });
};
export var disconnectSubscriber = function disconnectSubscriber(subscriberId) {
  var executionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var etfFeeOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var etfWaiveReasons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return function (dispatch) {
    return disconnectSubscriberPromise(dispatch, subscriberId, executionOptions, etfFeeOverride, etfWaiveReasons);
  };
};
var disconnectSubscriberPromise = function disconnectSubscriberPromise(dispatch, subscriberId, executionOptions, etfFeeOverride, etfWaiveReasons) {
  return ThunkHelper(dispatch, DISCONNECT_SUBSCRIBER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/DisconnectSubscriber',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: {
      BillingEffectiveDate: executionOptions.billingEffectiveDate,
      BillingEffectiveDateIntention: executionOptions.billingEffectiveIntention,
      Comment: executionOptions.disconnectComment,
      EarlyTerminationFeeOverrideReason: etfWaiveReasons,
      ExecutionDate: executionOptions.specifiedDate,
      ExecutionDateIntention: executionOptions.effective,
      IsEarlyTerminationFeeOverride: etfFeeOverride,
      ReasonCode: executionOptions.disconnectReason ? executionOptions.disconnectReason.Value || executionOptions.disconnectReason : undefined
    }
  });
};
export var SET_WAIVE_AND_REASON = 'SET_WAIVE_AND_REASON';
export var setWaiveAndReason = function setWaiveAndReason(reason) {
  return {
    type: SET_WAIVE_AND_REASON,
    payload: reason
  };
};
export var RESTORE_DEFAULT_ETF = 'RESTORE_DEFAULT_ETF';
export var restoreDefaultEtf = function restoreDefaultEtf() {
  return {
    type: RESTORE_DEFAULT_ETF
  };
};
export var TOGGLE_ETF_WAIVE = 'TOGGLE_ETF_WAIVE';
export var toggleEtfWaive = function toggleEtfWaive() {
  return {
    type: TOGGLE_ETF_WAIVE
  };
};
export var SET_DEFAULT_ETF_AMOUNT = 'SET_DEFAULT_ETF_AMOUNT';
export var setDefaultEtfAmount = function setDefaultEtfAmount(amount) {
  return {
    type: SET_DEFAULT_ETF_AMOUNT,
    payload: amount
  };
};
export var CLEAR_DISCONNECT_DATA = 'CLEAR_DISCONNECT_DATA';
export var clearDisconnect = function clearDisconnect() {
  return {
    type: CLEAR_DISCONNECT_DATA
  };
};
export var DISCONNECT_RETRIEVE_ORDER_CONTEXT = {
  BEGIN: 'DISCONNECT_RETRIEVE_ORDER_CONTEXT_BEGIN',
  SUCCESS: 'DISCONNECT_RETRIEVE_ORDER_CONTEXT_SUCCESS',
  FAILURE: 'DISCONNECT_RETRIEVE_ORDER_CONTEXT_FAILURE'
};
var DISCONNECT_RETRIEVE_ORDER_CONTEXT_TYPES = [DISCONNECT_RETRIEVE_ORDER_CONTEXT.BEGIN, DISCONNECT_RETRIEVE_ORDER_CONTEXT.SUCCESS, DISCONNECT_RETRIEVE_ORDER_CONTEXT.FAILURE];
export var retrieveOrderContext = function retrieveOrderContext(customerId) {
  return function (dispatch) {
    return retrieveOrderContextPromise(dispatch, customerId);
  };
};
export var retrieveOrderContextPromise = function retrieveOrderContextPromise(dispatch, customerId) {
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {}
  };
  return ThunkHelper(dispatch, DISCONNECT_RETRIEVE_ORDER_CONTEXT_TYPES, params);
};